import { Component, OnDestroy, OnInit } from '@angular/core';
import { Booking } from 'anchor-shared/lib/model/entity/booking';
import { ActivatedRoute, Router } from '@angular/router';
import { BookingDAO } from '../../../../../core/services/dao/bookingDAO';
import { ContainsSubscriptions } from '../../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-edit-booking',
  templateUrl: './edit-booking.component.html',
  styleUrls: ['./edit-booking.component.scss'],
})
export class EditBookingComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  subs: Subscription[] = [];
  public model: Booking;
  public selectedId: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private bookingDAO: BookingDAO,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.selectedId = +params['id'];
      const bookingSub = this.bookingDAO
        .getById(this.selectedId)
        .subscribe((booking) => {
          this.model = booking;
        });
      this.subs.push(bookingSub);
    });
  }

  ngOnDestroy(): void {}

  onSubmitted() {}

  onCancelled() {
    this.router.navigate(['manage/admin/bookings']);
  }
}
